var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2894_22366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 20C5 21.103 5.897 22 7 22H17C18.103 22 19 21.103 19 20V8H5V20ZM7 10H17L17.001 20H7V10Z",
    fill: "#FF5728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 5V3H9V5H3V7H21V5H15Z",
    fill: "#FF5728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12H9V18H11V12Z",
    fill: "#FF5728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 12H13V18H15V12Z",
    fill: "#FF5728"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2894_22366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.86b439a23f32f7943b0e8de8691b36e3.svg";
export { ForwardRef as ReactComponent };